(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["single-vs-multi-zone-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-svm2]').forEach((page) => {
    if (page.dataset.ready) return;
    page.dataset.ready = 'true';
    const tabs = page.querySelectorAll('[data-svm2-tab]');
    const panels = page.querySelectorAll('[data-svm2-panel]');
    const maxVisible = 9;

    const refreshPanel = (panel, resetVisible) => {
      const cards = [...panel.querySelectorAll('[data-svm2-product]')];
      if (!cards.length) return;
      if (!panel.dataset.series) panel.dataset.series = 'all';
      if (!panel.dataset.format) panel.dataset.format = 'all';
      if (!panel.dataset.voltage) panel.dataset.voltage = 'all';
      if (!panel.dataset.visible || resetVisible) panel.dataset.visible = String(maxVisible);
      const matches = cards.filter((card) => {
        const seriesMatch = panel.dataset.series === 'all' || card.dataset.series === panel.dataset.series;
        const formatMatch = panel.dataset.format === 'all' || card.dataset.format === panel.dataset.format;
        const voltageMatch = panel.dataset.voltage === 'all' || card.dataset.voltage === panel.dataset.voltage;
        return seriesMatch && formatMatch && voltageMatch;
      });
      const visible = Math.min(Number(panel.dataset.visible), maxVisible);
      cards.forEach((card) => {
        const matchIndex = matches.indexOf(card);
        card.hidden = matchIndex === -1 || matchIndex >= visible;
      });
      const visibleCount = panel.querySelector('[data-svm2-visible-count]');
      const resultCount = panel.querySelector('[data-svm2-result-count]');
      const resultName = panel.querySelector('[data-svm2-result-name]');
      const noResults = panel.querySelector('[data-svm2-no-results]');
      if (visibleCount) visibleCount.textContent = Math.min(matches.length, visible);
      if (resultCount) resultCount.textContent = matches.length;
      if (resultName) resultName.textContent = matches.length === 1 ? 'model' : 'models';
      if (noResults) noResults.hidden = matches.length !== 0;
    };

    panels.forEach((panel) => {
      panel.querySelectorAll('[data-svm2-series]').forEach((button) => {
        button.addEventListener('click', () => {
          panel.dataset.series = button.dataset.svm2Series;
          panel.querySelectorAll('[data-svm2-series]').forEach((item) => {
            const selected = item === button;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', String(selected));
          });
          refreshPanel(panel, true);
        });
      });
      panel.querySelectorAll('[data-svm2-voltage]').forEach((button) => {
        button.addEventListener('click', () => {
          panel.dataset.voltage = button.dataset.svm2Voltage;
          panel.querySelectorAll('[data-svm2-voltage]').forEach((item) => {
            const selected = item === button;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', String(selected));
          });
          refreshPanel(panel, true);
        });
      });
      panel.querySelectorAll('[data-svm2-format]').forEach((button) => {
        button.addEventListener('click', () => {
          panel.dataset.format = button.dataset.svm2Format;
          panel.querySelectorAll('[data-svm2-format]').forEach((item) => {
            const selected = item === button;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', String(selected));
          });
          refreshPanel(panel, true);
        });
      });
      const reset = panel.querySelector('[data-svm2-reset]');
      if (reset) reset.addEventListener('click', () => {
        panel.dataset.series = 'all';
        panel.dataset.format = 'all';
        panel.dataset.voltage = 'all';
        panel.querySelectorAll('[data-svm2-series="all"], [data-svm2-format="all"], [data-svm2-voltage="all"]').forEach((button) => button.click());
        refreshPanel(panel, true);
      });
      refreshPanel(panel, true);
    });

    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((item) => item.classList.toggle('is-active', item === tab));
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.svm2Panel !== tab.dataset.svm2Tab;
        panel.classList.toggle('is-active', !panel.hidden);
        if (!panel.hidden) refreshPanel(panel, false);
      });
    }));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
